import { InspirationType } from './types';

export const inspirationCategories: InspirationType['category'][] = [
  'GolfCourses',
  'GolfResorts',
  'Insights',
  'News',
  'GolfRegions',
  'TopLists'
];
